import { render, staticRenderFns } from "./ContainerDetail.vue?vue&type=template&id=1a55b73a"
import script from "./ContainerDetail.vue?vue&type=script&lang=js"
export * from "./ContainerDetail.vue?vue&type=script&lang=js"
import style0 from "./ContainerDetail.vue?vue&type=style&index=0&id=1a55b73a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports